import { decryptData } from "../utils/encryption";
import { getComID } from "./getComID";

export const getAuthData = () => {
    const encryptedAuthData = sessionStorage.getItem('user');
    const fallbackComID = getComID();
    const fallbackAuthData = fallbackComID ? { ComID: fallbackComID } : {};

    if (!encryptedAuthData) {
        return fallbackAuthData;
    }

    const authData = decryptData(encryptedAuthData);

    try {
        const parsedAuthData = JSON.parse(authData || '{}');
        return {
            ...fallbackAuthData,
            ...parsedAuthData,
            ComID: parsedAuthData?.ComID || fallbackComID,
        };
    } catch (e) {
        console.error('Failed to parse auth data from sessionStorage:', e);
        return fallbackAuthData;
    }
};
